import type { ITeam } from "@bbj-types/team";
import type { IUser } from "@bbj-types/user";
import { useCallback } from "react";
import { axiosUserV2 } from "./axios";

export type TGetUserAutocompleteResponse = (Pick<IUser, "_id" | "firstName" | "lastName" | "isDisabled"> & {
  teams: Pick<ITeam, "_id" | "name">[];
})[];

export interface IGetUserAutocompleteQuery {
  name?: string;
  permissions?: string[];
  excludedIds?: string[];
  showDisabled?: boolean;
  teams?: string[];
  organisation?: string;
}

export const useGetUserAutocomplete = () => {
  const [state, execute, cancel] = axiosUserV2<TGetUserAutocompleteResponse, undefined, unknown>(
    {
      url: "/autocomplete",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (query: IGetUserAutocompleteQuery) => {
      return execute({
        params: query,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
